import { useAuth0 } from '@auth0/auth0-react'
import { Box, Link, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { COLORS } from '~theme/colors'
import useBreakpoint from '~hooks/use-breakpoint'

interface footerLinksI {
  link: string
  label: string
}

const footerLinks: footerLinksI[] = [
  { link: '/contact-us', label: 'Contact' },
  { link: '/terms-and-conditions', label: 'Terms & Conditions' },
  { link: '/legal-notice', label: 'Legal Notice' },
  { link: '/privacy-policy', label: 'Privacy Policy' },
]

export function FooterLinks() {
  const { isAuthenticated } = useAuth0()

  if (isAuthenticated) {
    const index = footerLinks.findIndex((x) => x.label === 'Contact')
    if (index > -1) {
      footerLinks.splice(index, 1)
    }
  }

  return (
    <>
      {footerLinks.map(({ link, label }) => {
        return (
          <Box
            component={NavLink}
            to={link}
            key={link}
            sx={{ textDecoration: 'none', color: 'white' }}
          >
            <Typography
              variant="menu"
              sx={{ textDecoration: 'none', color: 'white' }}
            >
              {label}
            </Typography>
          </Box>
        )
      })}
    </>
  )
}
